<template>
    <div class="form-documents">
        <div class="input-container">
            <BorderedIconButton
                for="uploadFiles"
                class="add-button"
                :imgUrl="loadIcon"
                :title="$t('app.ask.estimate.document')"
                :onClick="triggerSelect"
            />
            <input
                class="invisible-input"
                id="uploadFiles"
                ref="uploadFiles"
                accept=".jpg, .jpeg, .png, .gif, .pdf"
                @change="addDocument"
                :value="this.uploadFilesResetValue()"
                type="file"
            />
        </div>
        <div class="form-documents-list">
            <RemovableItem
                v-for="document in documents"
                :key="document.name"
                :title="document.name"
                @remove="removeDocument(document)"
            />
        </div>
    </div>
</template>

<script lang="ts">
import BorderedIconButton from '@/components/ui-components/BorderedIconButton.vue';
import RemovableItem from '@/components/ui-components/RemovableItem.vue';
import { defineComponent, PropType, Ref, ref } from 'vue';

const extensionTypeValid = ['image/png', 'image/jpeg', 'application/pdf', 'image/gif'];

export default defineComponent({
    setup() {
        const uploadFiles: Ref<HTMLInputElement | undefined> = ref<HTMLInputElement>();

        return {
            uploadFiles,
        };
    },
    components: { RemovableItem, BorderedIconButton },
    props: {
        documents: { type: Array as PropType<File[]>, required: true },
    },
    computed: {
        loadIcon() {
            return require('@/assets/img/clip-icon.svg');
        },
        files(): File[] {
            return this.$store.getters.getInterventionFiles;
        },
    },
    methods: {
        addDocument(event: any) {
            const doc = event.target.files[0];
            const isFind = this.documents.find(d => d.name === doc.name);

            if (this.validDocType(doc) && !isFind) {
                this.$emit('add', doc);
            }
            this.uploadFilesResetValue();
        },
        removeDocument(file: File) {
            this.$emit('remove', file);
        },
        triggerSelect() {
            this.uploadFiles?.click();
        },
        uploadFilesResetValue() {
            return undefined;
        },
        validDocType(file: any) {
            return extensionTypeValid.includes(file.type);
        },
    },
});
</script>

<style scoped>
.add-button {
    max-width: 250px;
    margin-bottom: 22px;
}
.form-documents {
    padding-left: 30px;
    width: 45%;
}
.form-documents-list {
    width: 100%;
    display: flex;
    flex-flow: row wrap;
    gap: 24px 16px;
}
.invisible-input {
    display: none;
}
</style>
